/* eslint-disable camelcase */
import it_IT from './it_IT';
import en_EN from './en_EN';

export default { it_IT, en_EN };
